// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import { SearchFieldOptionsModel as selectOptionsModel } from "@store/Framework/Types/SearchFieldOptionsModel";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const parameter = state.pages.orderHistory.getOrdersParameter;
    return {
        ordersDataView: getOrdersDataView(state, parameter),
        parameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistoryTypeStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const orderHistoryTypeStyles: OrderHistoryTypeStyles = {};

const styles = orderHistoryTypeStyles;

const OrderHistorySearchFieldType: React.FunctionComponent<Props> = props => {
    let selectVal = props.parameter.additionalQueryStringParameters?.orderTypeFilter || "";
    const selectOptions: selectOptionsModel[] =
        "properties" in props.ordersDataView && "orderTypeList" in (props.ordersDataView as any).properties
            ? JSON.parse(props.ordersDataView.properties.orderTypeList)
            : [];

    const handleSelectChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            props.updateSearchFields({
                _orderTypeFilter: event.currentTarget.value,
                additionalQueryStringParameters: {
                    orderTypeFilter: event.currentTarget.value,
                },
            } as any);
        } else {
            props.updateSearchFields({
                _orderTypeFilter: undefined,
                additionalQueryStringParameters: {
                    orderTypeFilter: undefined,
                },
            } as any);
            selectVal = "";
        }
    };

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            {selectOptions && (
                <Select
                    label={translate("Order Type")}
                    value={selectVal}
                    onChange={handleSelectChange}
                    data-test-selector="orderHistory_filterType"
                >
                    <option value="">{translate("Select")}</option>
                    {selectOptions.map(item => (
                        <option key={item.key} value={item.key}>
                            {item.value}
                        </option>
                    ))}
                </Select>
            )}
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldType),
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Order Type",
    },
};

export default widgetModule;
